import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'FRETE_LITRO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'FRETE_LITRO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'FRETE_LITRO_FILTRO',
        payload: filtro
    };
}

export function initForm(registro = {}) {
    return [
        initialize('freteLitroForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/freteLitro?data=${DateFormat.formatarDataTelaParaSql(getState().freteLitro.filtro.data)}`)
		.then(resp => {
			dispatch({
		        type: 'FRETE_LITRO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		dispatch(setAguardando(true));
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/freteLitro`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(setAguardando(false));
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		} else {
			axios.put(`${consts.API_URL}/freteLitro`, {
				...registro,
				volume: FormatUtils.formatarValorBanco(registro.volume, 0),
				valor_km: FormatUtils.formatarValorBanco(registro.valor_km, 2),
				distancia: FormatUtils.formatarValorBanco(registro.distancia, 0),
				valor_despesa: FormatUtils.formatarValorBanco(registro.valor_despesa, 0),
				valor_frete: parseFloat(FormatUtils.formatarValorBanco(registro.volume, 0)) > 0 ? ((parseFloat(FormatUtils.formatarValorBanco(registro.distancia, 0) * parseFloat(FormatUtils.formatarValorBanco(registro.valor_km, 2)))) + parseFloat(FormatUtils.formatarValorBanco(registro.valor_despesa, 0))) / parseFloat(FormatUtils.formatarValorBanco(registro.volume, 0)) : 0,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(async resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(setAguardando(false));
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
				dispatch(setAguardando(false));
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/freteLitro?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
